module.exports = __webpack_public_path__ + "static/media/RoosterandtheDancingDiablo.66851420.jpg";